import useSWR, { type SWRConfiguration } from 'swr';
import denApi from '@/lib/api/denApi';
import { useAuthClient } from '@/lib/authClient';

type ExpiredHistoricTransactionCountResponse = {
  expiredTransactionCount: number;
};

type UseExpiredHistoricTransactionCountOptions =
  SWRConfiguration<ExpiredHistoricTransactionCountResponse> & {
    enabled?: boolean;
  };

const fetcher = async (
  url: string
): Promise<ExpiredHistoricTransactionCountResponse> =>
  await denApi.get<ExpiredHistoricTransactionCountResponse, void>(url);

export function useExpiredHistoricTransactionCount(
  options?: UseExpiredHistoricTransactionCountOptions
) {
  const session = useAuthClient().session;
  const { enabled = true, ...swrOptions } = options ?? {};

  const { data, error, isLoading, mutate } =
    useSWR<ExpiredHistoricTransactionCountResponse>(
      enabled && session.data ? 'transactions/historic/expired-count' : null,
      fetcher,
      { revalidateOnFocus: false, ...(swrOptions ?? {}) }
    );

  return {
    expiredTransactionCount: data?.expiredTransactionCount ?? 0,
    isLoading,
    error,
    refetch: mutate,
  };
}
